import React from 'react';

import SupportContainer from './SupportContainer';
import { SupportDetail } from './SupportDetail';

const SupportPage: React.FC = () => (
    <SupportContainer.Provider>
        <SupportDetail/>
    </SupportContainer.Provider>
);
export default SupportPage;
